// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.9141 22H8.08594L12 18.0859L15.9141 22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 20H16.7422L12 15.2578L7.25781 20H1.00098L1 3H23V20Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mode-preview-filled')
export default class ModePreviewFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mode-preview-filled',
    }
  }
}
